import { Routes } from '@angular/router';
import { adminGuard } from './core/auth/admin.guard';
import { authGuard } from './core/auth/auth.guard';
import { superAdminGuard } from './core/auth/super-admin.guard';
import { ShellComponent } from './core/layout/shell.component';

export const appRoutes: Routes = [
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./modules/auth/callback.component').then(m => m.CallbackComponent),
  },
  {
    // Authenticated app: everything renders inside the shell (header + left rail).
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./modules/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./modules/events/events-list/events-list.component').then(m => m.EventsListComponent),
      },
      {
        path: 'events/new',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./modules/events/event-create/event-create.component').then(m => m.EventCreateComponent),
      },
      {
        path: 'events/:id/edit',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./modules/events/event-create/event-create.component').then(m => m.EventCreateComponent),
      },
      {
        path: 'events/:id/registrations',
        loadComponent: () =>
          import('./modules/events/event-registrations/event-registrations.component')
            .then(m => m.EventRegistrationsComponent),
      },
      {
        path: 'events/:eventId/registrations/:registrationId',
        loadComponent: () =>
          import('./modules/registration/registration-detail/registration-detail.component')
            .then(m => m.RegistrationDetailComponent),
      },
      {
        path: 'tools',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./modules/admin/super-admin-tools.component').then(m => m.SuperAdminToolsComponent),
      },
      {
        // Reached from the SuperAdmin tools page or the discreet link on a registration, never from
        // the roster a volunteer works in.
        path: 'registrations/:registrationId/void',
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./modules/registration/void-registration/void-registration.component')
            .then(m => m.VoidRegistrationComponent),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./modules/registration/register/register.component').then(m => m.RegisterComponent),
      },
      {
        path: 'checkin',
        loadComponent: () =>
          import('./modules/checkin/check-in.component').then(m => m.CheckInComponent),
      },
      {
        // New clients created over a strong duplicate warning. A read-only list to check; any fix is
        // made on the records themselves.
        path: 'duplicates',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./modules/duplicates/dismissed-duplicates.component').then(m => m.DismissedDuplicatesComponent),
      },
      {
        path: 'reports',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./modules/reports/reports.component').then(m => m.ReportsComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
